export const initialState = {
    showNavbar: true
}
